(function () {
    'use strict';

    angular
        .module('atcCallSign')
        .factory('AtcCallSignFactory', AtcCallSignFactory);

    function AtcCallSignFactory() {

      function AtcCallSignSearchRequestDTO() {
        this.fromDate = null;
        this.toDate = null;
        this.flightNo = null;
        this.atcCallSign = null;
        this.actType = null;

      }

      function AtcSaveRequest() {
        this.atcCallSignId = null;
        this.flightNumber = null;
        this.atcCallSign = null;
        this.adHoc = false;
        this.validFromStr = null;
        this.validToStr = null;
      }

      function AtcDeleteRequest() {
        this.atcCallSignId = null;
      }


    	function GetAtcSearchParams(params){
    		var searchReq = new AtcCallSignSearchRequestDTO();
        searchReq.fromDate = params.fromDate;
        searchReq.toDate = params.toDate;
        searchReq.flightNo = params.flightNo;
        searchReq.atcCallSign = params.atcCallSign;
        searchReq.actType = params.type !== null && !angular.isUndefined(params.type)? params.type.value :null;
        return searchReq;
        }

      function SetSelectedData(data) {
    	  var detail = new AtcSaveRequest();
        detail.atcCallSignId = data.atcCallSignId;
        detail.flightNumber = data.flightNumber;
        detail.atcCallSign = data.atcCallSign;
        detail.adHoc = data.atcSignFlag == "ADH"? true:false;
        detail.validFromStr = data.validFromStr;
        detail.validToStr = data.validToStr;

        return detail;

      }

      function GetDeleteParams(data) {
    	  var det = new AtcDeleteRequest();
    	  det.atcCallSignId = data.atcCallSignId;
        return det;
      }

      function GetNewSaveRequest() {
        return new AtcSaveRequest();
      }


        return {
          getSearchParams : GetAtcSearchParams,
          setSelectedData : SetSelectedData,
          getNewSaveRequest :GetNewSaveRequest,
          getDeleteParams : GetDeleteParams
        }

    }
})();
